import { motion } from 'framer-motion'

interface BackdropProps {
  onClick: () => void
}

/**
 * Wave 7b: Full-screen translucent backdrop behind the voice bot panel.
 * Click is forwarded to the parent's gated close handler (caller decides
 * whether the click should actually dismiss based on session state).
 */
export const Backdrop = ({ onClick }: BackdropProps) => (
  <motion.div
    key="backdrop"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    style={{
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      zIndex: 9998,
    }}
    onClick={onClick}
  />
)
